export const isAfterTomorrow = date => {
  const now = new Date()
  now.setHours(0, 0, 0, 0)
  const diff = date - now.getTime()

  return diff > 48 * 3600 * 1000
}
